import React, { useState } from "react";
import homeLogo from "../assets/images/mocaverse.svg";
import comingSoon from "../assets/images/comingsoon.svg";
import Twitter from "../assets/images/twitter-yellow.svg";
import Modal from "../components/Modal";
import ModalCriteria from "../components/ModalCriteria";

const LearnAnimation = React.lazy(() => import("./LearnRealm"));
const InvestAnimation = React.lazy(() => import("./InvestRealm"));
const PlayAnimation = React.lazy(() => import("./PlayRealm"));
const DoGoodAnimation = React.lazy(() => import("./DoGoodRealm"));

const LearnTextAnimation = React.lazy(() => import("./LearnRealmText"));
const InvestTextAnimation = React.lazy(() => import("./InvestRealmText"));
const PlayTextAnimation = React.lazy(() => import("./PlayRealmText"));
const DoGoodTextAnimation = React.lazy(() => import("./DoGoodRealmText"));

function Intro() {
  const [showModal, setShowModal] = useState(false);
  const [showModalCriteria, setModalCriteria] = useState(false);

  return (
    <>
      {showModal && <Modal toggleModal={() => setShowModal(false)} />}
      {showModalCriteria && (
        <ModalCriteria toggleModal={() => setModalCriteria(false)} />
      )}
      <section id="home" className="intro orbit-rings">
        <div className="intro__wrapper">
          <div className="home-logo-counter-block">
            <IntroRegistration
              handleModal={() => setShowModal(true)}
              handleModalCriteria={() => setModalCriteria(true)}
            />
          </div>
          <div className="learn-realm">
            <LearnTextAnimation />
            <LearnAnimation />
          </div>
          <div className="dogood-realm">
            <DoGoodTextAnimation />
            <DoGoodAnimation />
          </div>
          <div className="invest-realm">
            <InvestTextAnimation />
            <InvestAnimation />
          </div>
          <div className="play-realm">
            <PlayTextAnimation />
            <PlayAnimation />
          </div>
        </div>
      </section>
    </>
  );
}

export default Intro;

const IntroRegistration = ({ handleModal, handleModalCriteria }) => {
  return (
    <>
      <div className="home-wrapper">
        <img src={homeLogo} alt="OFF TO THE REALMS" className="home-logo" />
        <div className="board">
          <div className="board-bg">
            <div className="registration">
              <h2 className="registration-title">Mocalist Registration</h2>
              <div className="registration-msg">
                <p>Registration opens: 13 JANUARY 2023</p>
              </div>
              <div className="registration-info">
                <p>
                  After registration, eligible parties will receive a Realm
                  Ticket airdrop for a chance to win a Mocalist spot
                  (eligibility for 1 free mint and 1 paid mint).
                </p>
                <p>
                  <strong>Snapshot date: 8 am (EST), 12 JANUARY 2023</strong>
                </p>
              </div>
              {/* <button type="button" className="btn btn-md register" disabled>
                Register
              </button> */}
              <button
                type="button"
                className="btn-link"
                onClick={handleModalCriteria}
              >
                How to join?
              </button>
            </div>
          </div>
        </div>
        <button type="button" className="btn signup" onClick={handleModal}>
          Get Updates
        </button>
        <p className="signup-info">
          Sign up for updates about Mocaverse and the Mocalist Registration!
        </p>
        <IntroSocial />
      </div>
    </>
  );
};

const IntroSocial = () => {
  return (
    <div className="socials-links-mobile">
      <ul>
        <li>
          <a
            href="https://twitter.com/MocaverseNFT"
            className="socials"
            target="_blank"
            without
            rel="noreferrer"
          >
            <img src={Twitter} alt="Twitter" />
          </a>
        </li>
      </ul>
    </div>
  );
};
